import React, { useState, useEffect } from "react";
import StaffIDCard from "../inputComponents/StaffIDCard";
const ModalBulkStaffIDCard = (props) => {
  const [itemValues, setItemValues] = useState([]);
  const [itemReferenceNo, setItemReferenceNo] = useState("");

  let path = window.location.origin;

  // Encrypt Decrypt Data //
  const encrypt = (encrypDycrypData, type) => {
    let result;
    if (type === "Encrypt") {
      result = window.btoa(encrypDycrypData);
    } else if (type === "Decrypt") {
      result = window.atob(encrypDycrypData);
    }
    return result;
  };

  useEffect(() => {
    setItemValues(props.itemId);
    setItemReferenceNo(props.referenceNo);
  }, [props.itemId, props.referenceNo]);

  return (
    <>
      <table width="515" border="0" cellspacing="0" cellpadding="0">
        <tr>
          <td>
            <table>
              <tr>
                <td>
                  {itemValues.map((allItems, index) => {
                    if (index % 2 === 0) {
                      let referenceNo =
                        path +
                        "/verifystaffidcard?payload=" +
                        encrypt(allItems.fileNumber, "Encrypt");

                      return (
                        <>
                          <tr key={index}>
                            <td align="center">
                              <StaffIDCard
                                itemValues={allItems}
                                itemReferenceNo={referenceNo}
                              />
                            </td>
                          </tr>
                        </>
                      );
                    }
                  })}
                </td>

                <td>
                  {itemValues.map((allItems, index) => {
                    if (index % 2 !== 0) {
                      let referenceNo =
                        path +
                        "/verifystaffidcard?payload=" +
                        encrypt(allItems.fileNumber, "Encrypt");

                      return (
                        <>
                          <tr key={index}>
                            <td align="center">
                              <StaffIDCard
                                itemValues={allItems}
                                itemReferenceNo={referenceNo}
                              />
                            </td>
                          </tr>
                        </>
                      );
                    }
                  })}
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </>
  );
};
export default ModalBulkStaffIDCard;
